import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
export { LinkCopied } from './link-copied/link-copied';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import LinkIcon from '../../../../../icons/compiled/components/LinkIcon';
import parentStyles from '../styles.scss';
import styles from './styles.scss';
export class Link extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleClick", () => {
      const {
        canShareContent
      } = this.props;
      if (canShareContent) {
        this.copyToClipboard();
      }
      this.props.onClick();
    });
    _defineProperty(this, "saveRef", ref => {
      this.ref = ref;
    });
  }
  copyToClipboard() {
    if (document.queryCommandSupported('copy')) {
      this.ref.select();
      document.execCommand('copy');
    }
  }
  render() {
    const {
      dataHook,
      className,
      ariaLabel,
      instanceInfo,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      className: className,
      "data-hook": dataHook,
      onClick: this.handleClick,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(LinkIcon, null),
      className: parentStyles.icon
    }), instanceInfo && /*#__PURE__*/React.createElement("input", {
      type: "text",
      ref: this.saveRef,
      tabIndex: "-1",
      readOnly: true,
      className: styles.utilityInput,
      value: instanceInfo.siteUrl
    })));
  }
}
//# sourceMappingURL=link.js.map